module.exports = __webpack_public_path__ + "img/lesson_delete.9753252f.svg";